import React from 'react';
import { FiLoader } from 'react-icons/fi';

interface InlineSpinnerProps {
  className?: string;
}

export const InlineSpinner: React.FC<InlineSpinnerProps> = ({ className }) => (
  <FiLoader className={`animate-spin ${className}`} aria-hidden="true" />
); 